import { render, staticRenderFns } from "./parametrosPagamento.vue?vue&type=template&id=13e241ac&scoped=true&"
import script from "./parametrosPagamento.vue?vue&type=script&lang=js&"
export * from "./parametrosPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e241ac",
  null
  
)

export default component.exports